var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", xl: "4" } },
        [_c("app-label", { attrs: { label: "nl-be", value: _vm.value.nlBe } })],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", xl: "4" } },
        [_c("app-label", { attrs: { label: "en", value: _vm.value.en } })],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", xl: "4" } },
        [_c("app-label", { attrs: { label: "fr", value: _vm.value.fr } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }